<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "TV Shows",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
         return {
            title: "TV Shows",
            items: [
               {
                  text: "TV Shows",
                  active: true,
               },                   
            ],

            tvshows: [],
            tvs:[],
            agencies:[],

            tvshow: {
               id: "",
               type: "",
               pharmacy_id : "",
               title: "",
               video: "",
            },
            
            video: "",

            modal_title: "Add TV Show",
            button_title: "Save",
            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,         
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},
            tv_id: "",
            pharmacy: "",
            agency_id:"",
            delete: "",
            expiry: "",
            agency: "",
            slot: "",
            duration: "",
            from_date: today_str,
         };
      },
      mounted() {

      },

      created() {
         this.fetchTVShows();
         this.fetchTvs();
         this.fetchAgencies();
      },

      methods: {

         getToken() {
            if (localStorage.getItem('medicino_pharmacy')) {
               var medicino_pharmacy =  JSON.parse(localStorage.getItem('medicino_pharmacy'));
               if(medicino_pharmacy.token) {
                  this.token = medicino_pharmacy.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchTVShows(page_url = null) {

            this.getToken();
            let url = "pharmacy/tvshows?keyword=" + this.keyword + "&limit=" + this.listing_length;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.tvshows = responseData.tv_shows.data;
                  this.pharmacy = responseData.pharmacy;
                  this.pagination = responseData.tv_shows.links;
                  this.from = responseData.tv_shows.from;
                  this.to = responseData.tv_shows.to;
                  this.total = responseData.tv_shows.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },         

         fetchTvs() {

            this.getToken();
            let url = "pharmacy/getTvs";
            this.loading = true;

            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.tvs = responseData.tv;
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         fetchAgencies() {
               let url = "api/admin/getAgencies";         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.agencies = responseData.agencies;
                  })
                  .catch((err) => console.log(err));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         setFile(e) {
            this.video = e.target.files[0];
         },

         clearForm() {           
            
            this.modal_title = "Add TV Show";
            this.button_title = "Add";
            this.tvshow.id = "";
            this.tvshow.type = "";
            this.tvshow.pharmacy_id = "";    
            this.tvshow.title = "";
            this.tvshow.video = "";
            this.edit = false;
            this.tv_id = "";
            this.video = "";
            this.agency_id = "";
            this.errors = {};
            this.pharmacies = [];
            this.expiry = "";
            this.slot = "";
            this.duration = "";
         },
         addTVShow() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "pharmacy/tvshow/add";
            this.active_page_url = null;
            let formData = new FormData();
            formData.append("tv_id", this.tv_id); 
            formData.append("agency_id", this.agency_id); 
            formData.append("title", this.tvshow.title); 
            formData.append("duration", this.duration); 
            formData.append("slot", this.slot); 
            formData.append("validity", this.expiry);
         
            if(this.video) {
               formData.append("video", this.video); 
            } else {
               formData.append("video", ""); 
            }

         
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('tvshow-modal');
                  this.fetchTVShows(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         deleteTVShow(tvshow_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this TV show?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                  console.log(this.token);
                  let formData = new FormData();
                  formData.append("tv_show_id", tvshow_id); 

                  // var formData = JSON.stringify({
                  //    "tv_show_id": tvshow_id
                  // });

                  let url = "pharmacy/tvshow/delete";
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchTVShows(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.tvshow-modal variant="primary" class="float-end">Add TV Show</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchTVShows()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchTVShows()"/>
                           </label>
                        </div>                     
                        <!-- <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status">
                                 <option :value="null">All</option>
                                 <option value="1">Published</option>
                                 <option value="0">Unpublished</option>
                              </select>
                           </label>
                        </div>    -->
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th>SI No</th>
                              <th>Show Name</th>
                              <th>Video</th>
                              <th>Tvs</th>
                              <th >Duration & Slot, Validity</th>
                              <th>Agent</th>
                              <th>Created By</th>
                              <th>Created On</th>
                              <th>Options</th>                              
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(tvshows.length)">
                           <tr v-for="(tvshow, index) in tvshows" :key="tvshow.id">
                              <td>{{index + from}}</td>
                              <td>{{tvshow.title}}</td>
                              <td>
                                 <a :href="$image_url + tvshow.video" target="_blank" class="font-size-22"><i class='bx bx-video'></i></a>
                              </td>
                              <td>
                                 <span v-if="tvshow.names && tvshow.names.length">
                                    <span v-for="(name, index) in tvshow.names" :key="index">
                                          {{ name }}<br>
                                    </span>
                                 </span> 
                                 <span v-else>All</span>          
                              </td>
                              <td>{{tvshow.duration}} sec - {{tvshow.slot}} slots<br> {{tvshow.validity| formatDate}}</td>
                              <td>{{tvshow.name}}</td>                   
                              <td><span v-if="tvshow.added_by==1">Admin</span><span v-else>{{pharmacy}}</span></td>
                              <td>{{tvshow.created_at | formatDateTime}}</td>
                              <td>
                                 
                                 <button class="btn btn-danger btn-sm mb-2" type="button" @click="deleteTVShow(tvshow.id)">Delete</button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="9" class="text-center">No tv shows found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(tvshows.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchTVShows(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="tvshow-modal" id="tvshow-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addTVShow()">                      
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Agency <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="agency_id" v-bind:class="{ 'is-invalid': Boolean(errors.agency_id) }" >
                                          <option value="">Select</option>
                                          <option :value="agency.id" v-for="agency in agencies" :key="agency.id"> {{agency.name}}</option>
                                       </select> 
                                       <div v-for="(val, index) in errors.agency_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Show Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="tvshow.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }"></b-form-input>
                              <div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Tv <span class="text-danger">*</span></label>
                                 <select class="form-control" v-model="tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                    <option value="">Select</option>
                                    <option :value="tv.id" v-for="tv in tvs" :key="tv.id">  {{ tv.name }}</option>
                                 </select> 
                                 <div v-for="(val, index) in errors.tv_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Duration(Sec) <span class="text-danger">*</span></label>
                              <b-form-input v-model="duration" v-bind:class="{ 'is-invalid': Boolean(errors.duration) }"></b-form-input>
                              <div v-for="(val, index) in errors.duration" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Slot<span class="text-danger">*</span></label>
                              <b-form-input type="text" v-model="slot" v-bind:class="{ 'is-invalid': Boolean(errors.slot) }"></b-form-input>
                              <div v-for="(val, index) in errors.slot" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Expiry Date <span class="text-danger">*</span></label>
                              <b-form-input type="date" v-model="expiry" :min="from_date" v-bind:class="{ 'is-invalid': Boolean(errors.validity) }"></b-form-input>
                              <div v-for="(val, index) in errors.validity" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>


                           <b-col md="12" class="form-group" v-if="!edit">
                              <label class="control-label">Video <span class="text-danger">*</span></label>
                              <input type="file" @change="setFile($event)" accept=".mp4" class="form-control" :class="{ 'is-invalid': Boolean(errors.video) }">

                              <div v-for="(val, index) in errors.video" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('tvshow-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
